import { render, staticRenderFns } from "./email-child.vue?vue&type=template&id=500daaec&"
import script from "./email-child.vue?vue&type=script&lang=js&"
export * from "./email-child.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports